// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1luEl","left":"styles_left__1yErh"};